'use client';

import { CenteredContainer } from '@nerdwallet/currency/components/CenteredContainer';

export default function NotFound(): JSX.Element {
  return (
    <CenteredContainer>
      <h2>404 - Not Found</h2>
      <p>The page you requested does not exist!</p>
    </CenteredContainer>
  );
}
